import styles from "./Header.module.css";

type HeaderProps = {
  title: string;
  subtitle: string;
};

export const Header = ({ title, subtitle }: HeaderProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.headerLeft}>
        <div className={styles.icon}></div>
        <span className={styles.appName}>Lokalizator Palet</span>
      </div>
      <div className={styles.headerCenter}>
        <h1 className={styles.modeTitle}>{title}</h1>
      </div>
      <div className={styles.headerRight}></div>
    </div>
  );
};
